import { SCREEN_METADATA, USER_METADATA } from '../../../../constants';
import { axios } from '../../../../lib';
import { IScreen } from '../types/screens-model';
import { IUserMetadata } from '../types/user-meta-model';

const dummyData: any = {
  user: 1,
  source: 1,
  source_name: 'dummy',
  user_name: 'dummy',
  role: ['dummy'],
  usertype: ['dummy'],
  screenInfo: [
    {
      screen_id: 1,
      screen_name: 'Pricing Simulator',
      embed_url: 'dummy'
    }
  ]
};

export default function fetchUserMetadata() {
  return axios.get<IUserMetadata[]>(USER_METADATA)
    .then((response) => {
      return Promise.resolve(response);
    });
  // return dummyData;
}

export function fetchScreensMetadata() {
  return axios.get<{ results: IScreen[] }>(SCREEN_METADATA);
}
